<template>
  <CollapseSection>
    <div>
      box_title {{ config.box_title }}
      <input
        v-model="config.box_title"
        @change="titleChange"
        @keyup="titleType"
      />
    </div>
    <div>
      title_color {{ config.title_color }}
      <input
        type="color"
        @change="titleColorChange"
        v-model="config.title_color"
      />
    </div>
    <div>
      title_justify {{ config.title_justify }}
      <b-form-group v-slot="{ ariaDescribedby }">
        <b-form-radio
          v-model="config.title_justify"
          :aria-describedby="ariaDescribedby"
          name="some-radios"
          value="left"
          @change="titleJustifyChange"
          >left</b-form-radio
        >
        <b-form-radio
          v-model="config.title_justify"
          :aria-describedby="ariaDescribedby"
          name="some-radios"
          value="center"
          @change="titleJustifyChange"
          >center</b-form-radio
        >
        <b-form-radio
          v-model="config.title_justify"
          :aria-describedby="ariaDescribedby"
          name="some-radios"
          value="right"
          @change="titleJustifyChange"
          >right</b-form-radio
        >
      </b-form-group>
    </div>
  </CollapseSection>
</template>

<script>
import { CollapseSection } from "../Overlay.styled";

export default {
  components: {
    CollapseSection,
  },
  methods: {
    titleChange() {
      this.$store.dispatch("design/snapshot/genSnapshot");
      // this.$store.dispatch("design/renderIFrame");
    },
    titleType() {
      this.$store.dispatch("design/renderIFrame");
      // this.$store.dispatch("design/renderIFrame");
    },
    titleJustifyChange() {
      this.$store.dispatch("design/snapshot/genSnapshot");
      // this.$store.dispatch("design/renderIFrame");
    },
    titleColorChange() {
      this.$store.dispatch("design/snapshot/genSnapshot");
      // this.$store.dispatch("design/renderIFrame");
    },
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style>
</style>